import { Link as MuiLink } from '@mui/material'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

import styles from './styles.module.scss'
import { ULinkProps } from './type'

export const ULink = ({
  to,
  href,
  children,
  variant,
  underline = 'always',
  className,
  ...props
}: ULinkProps) => {
  if (to) {
    return (
      <Link href={to} passHref>
        <MuiLink
          component="span"
          underline={underline}
          color="primary"
          className={clsx(className, styles[variant])}
          {...props}
        >
          {children}
        </MuiLink>
      </Link>
    )
  }
  if (href) {
    return (
      <MuiLink
        href={href}
        underline={underline}
        color="primary"
        className={clsx(className, styles[variant])}
        {...props}
      >
        {children}
      </MuiLink>
    )
  }
  return null
}
